<template>
  <BaseModal status="error" size="small">

    <div class="flex justify-center flex-col items-center">
            <div class="border-4 border-vw-red rounded-full h-16 w-16 flex items-center justify-center mb-4">
                <i class="fa-solid fa-xmark text-vw-red text-4xl p-4"></i>
            </div>

            <h3 class="text-xl text-vw-red mb-2 futura-bold">{{ $t('Bezorgadres') }}</h3>
            <p class="my-2">{{ $t('Weet u zeker dat je dit adres uit de standaard bezorg adressen van dit contact wil verwijderen?')}}</p>
            <a @click="confirm()" class="bg-vw-red border-2 border-vw-red text-white px-8 py-2 rounded-md mt-4 hover:cursor-pointer">{{ $t('Verwijderen') }}</a>
        </div>

  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal";
import InputField from "@/components/form/InputField";
import {MODAL_CONFIRM_REMOVE_ADDRESS, OPEN_MODAL} from "@/constants";

export default {
  name: 'RemoveAddressModal',
  components: {InputField, BaseModal},
  methods: {
    confirm(){
      this.$store.dispatch(MODAL_CONFIRM_REMOVE_ADDRESS);
    }
  }
}
</script>
